import { render, staticRenderFns } from "./ProxyDetect.vue?vue&type=template&id=2e7c9d9a&scoped=true"
import script from "./ProxyDetect.vue?vue&type=script&lang=js"
export * from "./ProxyDetect.vue?vue&type=script&lang=js"
import style0 from "./ProxyDetect.vue?vue&type=style&index=0&id=2e7c9d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7c9d9a",
  null
  
)

export default component.exports